import { CardComponentProps } from "@~/types/types";
import styles from "./GiftMessagesIndicator.module.scss";
import { IconButton as V31IconButton } from "@JohnLewisPartnership/jl-design-system/dist/components/button/Button";
import { IconButton as DeprecatedIconButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/IconButton";
import { FeedbackOutlined } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/FeedbackOutlined";
import { VIEW_GIFT_MESSAGES } from "@~/utils/events";
import { useFeatureFlags } from "@~/flags/flags";

export function GiftMessagesIndicator({
  product,
}: Pick<CardComponentProps, "product">) {
  const { isJldsV31Enabled } = useFeatureFlags();
  const { giftMessageCount = 0 } = product;

  if (giftMessageCount === 0) {
    return null;
  }

  const handleClick = () => {
    window.dispatchEvent(
      new CustomEvent(VIEW_GIFT_MESSAGES, {
        detail: { pimProductId: product.aliases.pimProductId },
      }),
    );
  };

  return (
    <div
      data-component="pcl-GiftMessagesIndicator"
      className={styles.giftMessagesButton}
    >
      <>
        {isJldsV31Enabled?.value ? (
          <V31IconButton
            onClick={handleClick}
            data-testid="view-messages-button"
            aria-label="View messages"
            size="small"
            icon={FeedbackOutlined}
          />
        ) : (
          <DeprecatedIconButton
            onClick={handleClick}
            data-testid="view-messages-button"
            ariaLabel="View messages"
            size="small"
            IconComponent={FeedbackOutlined}
          />
        )}
        <div className={styles.countIndicator}>
          <div className={styles.countText}>{giftMessageCount}</div>
        </div>
      </>
    </div>
  );
}
